export default __webpack_public_path__ + "static/media/servers.bfc5f5ec.svg";